import "../phaser.min.js";
import Deer from "../Scenes/Deer.js";
import Common from "../Includes/Common.js";
class ReflectionBackground extends Phaser.Scene {
    constructor() {
        super('ReflectionBackground');
        this.common = new Common();
    }

    init(data) {
        this.scrollSpeed = data.scrollSpeed;
        this.bgEvents = [
            ['happy', 'deer'],
            ['happy', 'duck'],
            ['happy', 'duck'],
            ['bigfoot'],
            ['sixseven', 'duck'],
            ['happy', 'duck'],
            ['sixseven', 'duck'],
            ['happy', 'duck'],
            ['happy', 'duck'],
            ['exclamation', 'deer'],

        ]
        this.eventQueue = structuredClone(this.bgEvents);
        this.deerScene = null;
    }

    preload() {
        this.load.atlas('bigfoot', this.common.assetsPath + 'sprites/sasquatch.png', this.common.assetsPath + 'sprites/sasquatch.json');
    }

    create(time, delta) {

        this.sasSFX = this.sound.add('sas', {volume: this.common.blipVolume, detune: -500})

        this.sky = this.add.tileSprite(0, 0, this.scale.width, 111, 'level', 'sky2')
                .setScale(this.common.gameScale)
                .setOrigin(0, 0)

        this.bgTrees = this.add.tileSprite(0, 55 * 4, this.scale.width, 60, 'level', 'background-trees')
                .setScale(this.common.gameScale)
                .setOrigin(0, 0)
                .setLighting(true)

        this.lights.enable();
        const light = this.lights.addLight(this.scale.width / 2, 100, 9000, 0xffffff, 1);

        this.sasquatch = this.add.sprite(this.scale.width - 1000, 100 * 4, 'bigfoot', 0)
                .setScale(this.common.gameScale)

        this.road = this.add.tileSprite(0, 31 * 4, this.scale.width, 111, 'level', 'road')
                .setScale(this.common.gameScale)
                .setOrigin(0, 0).setLighting(true)

        this.skyReflection = this.add.tileSprite(this.scale.width, this.scale.height, this.scale.width, 111, 'level', 'sky2')
                .setOrigin(0, 0)
                .setAngle(180)
                .setScale(this.common.gameScale)
                .setAlpha(0.3)
                .setFlipX(true).setLighting(true)

        this.bgTreesReflection = this.add.tileSprite(this.scale.width, 840, this.scale.width, 61, 'level', 'background-trees')
                .setOrigin(0, 0)
                .setAngle(180)
                .setScale(this.common.gameScale)
                .setFlipX(true)
                .setAlpha(0.4).setLighting(true)

        this.roadReflection = this.add.tileSprite(this.scale.width,  150 * 4, this.scale.width, 87, 'level', 'road')
                .setOrigin(0, 1)
                .setAngle(180)
                .setScale(this.common.gameScale)
                .setFlipX(true)
                .setAlpha(0.8).setLighting(true)

        this.waterOverlay = this.add.tileSprite(0, this.scale.height, this.scale.width, 120, 'level', 'water-overlay')
                .setScale(this.common.gameScale)
                .setOrigin(0, 1).setLighting(true)

        this.ripples = this.add.tileSprite(0, this.scale.height, this.scale.width, 120, 'level', 'ripples')
                .setScale(this.common.gameScale)
                .setOrigin(0, 1)

        this.lakeGround = this.add.tileSprite(0,136 * 4, this.scale.width, 41, 'level', 'lake-ground')
                .setScale(this.common.gameScale)
                .setOrigin(0, 0).setLighting(true)

        if(!this.anims.exists('walk')) {
            this.anims.create({
                key: 'walk',
                frames: this.anims.generateFrameNames('bigfoot', {
                    prefix: 'sasquatch ',
                    start: 0,
                    end: 7,
                    zeroPad: 0,
                    suffix: '.aseprite'
                }),
                frameRate: 4,
                repeat: -1 // -1 means infinite looping
            });
        }

        this.sasquatch.play('walk')
        this.addEventListeners();
    }

    update(time, delta) {
        let deltaSeconds = delta / 1000;
        this.sky.tilePositionX += this.scrollSpeed * 0.05 * deltaSeconds;
        this.skyReflection.tilePositionX += this.scrollSpeed * 0.05 * deltaSeconds;

        this.bgTrees.tilePositionX += this.scrollSpeed * 0.5 * deltaSeconds;
        this.bgTreesReflection.tilePositionX += this.scrollSpeed * 0.5 * deltaSeconds;

        this.road.tilePositionX += this.scrollSpeed * deltaSeconds;
        this.roadReflection.tilePositionX += this.scrollSpeed * deltaSeconds;

        this.sasquatch.x -= (this.scrollSpeed * 0.5 * this.common.gameScale * deltaSeconds);
        if(this.sasquatch.x < -200){
            this.sasquatch.setVisible(false);
        }

        this.waterOverlay.tilePositionX += this.scrollSpeed * 1.2 * deltaSeconds;
        this.ripples.tilePositionX += this.scrollSpeed * 1.5 * deltaSeconds;
        this.lakeGround.tilePositionX += this.scrollSpeed * 1.2 * deltaSeconds;

        if(this.ducks != undefined && this.ducks.getChildren().length > 0) {
            let children = this.ducks.getChildren();
            for (let child of children) {
                child.x -= this.scrollSpeed * 1.5 * this.common.gameScale * deltaSeconds;
                if (child.x < -100 * this.common.gameScale) {
                    child.x = this.scale.width * 1.25;
                }
            }
        }
    }

    carEventHandler() {
        this.car = this.scene.get('Car')
        this.events.on('love', () => {
            this.car.showEmote('heart-emote')
        }, this)

        this.events.on('happy', () => {
            this.car.showEmote('happy-emote')
        }, this)

        this.events.on('sixseven', () => {
            this.car.showEmote('67-emote')
        }, this)

        this.events.on('bigfoot', ()=>{
            this.sasquatch.x = this.scale.width + 100;
            this.sasquatch.setVisible(true);
            this.car.showEmote('bigfoot-emote')
            this.sasSFX.play();
        }, this)

        this.events.on('exclamation', ()=>{
            this.car.showEmote('exclamation-emote')
        })
    }

    addEventListeners() {
        if(this.scene.get('Car')){
            this.carEventHandler();
        }

        if(this.scene.get('Quiz')){
            this.quizEventHandler();
        }

        this.events.on('deer', ()=>{
            if(!this.deerScene) {
                this.scene.add('Deer', Deer)
                this.scene.launch('Deer', {scrollSpeed: this.scrollSpeed, baseSpeed: 1.2, y: 545})
                this.scene.moveBelow('Question', 'Deer')
                this.deerScene = this.scene.get('Deer');
            }else{
                this.deerScene.addDeer();
            }
        })

        this.events.on('duck', ()=>{
            if(this.ducks == undefined){
                this.ducks = this.add.group();
            }
            const min = this.scale.height/12 * 8;
            const max = this.scale.height/12 * 9;
            const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
            this.newDuck = this.ducks.create(this.scale.width * 0.95, this.scale.height/12 * 9 + 30, 'level', 'duck')
            this.tweens.chain({
                targets: this.newDuck,
                tweens: this.common.popUpTweenChain(randomNumber)})
        })

        this.events.on('sleep', () => {
            this.events.off('duck', null, this);
            this.events.off('deer', null, this);
            this.events.off('happy', null, this);
            this.events.off('sixseven', null, this);
            this.events.off('bigfoot', null, this);
            this.events.off('exclamation', null, this);
            this.events.off('love', null, this);
        });

        this.events.on('wake', this.onSceneWake, this);

        const backgroundManager = this.scene.get('BackgroundManager');
        backgroundManager.events.on('ReflectionBackground-fire-background-event', () => {
            let bgEvent = this.eventQueue.pop();
            if(Array.isArray(bgEvent)) {
                bgEvent.forEach(event => {
                    this.events.emit(event);
                })
            }else{
                this.events.emit(bgEvent);
            }
        }, this)
        backgroundManager.events.on('ReflectionBackground-fade-out', () => {
            this.add.tween({
                targets: [this.sky, this.skyReflection, this.bgTrees, this.bgTreesReflection, this.road, this.roadReflection, this.grass, this.waterOverlay, this.ripples, this.lakeGround, this.sasquatch].concat(this.ducks.getChildren() ?? []),
                alpha: 0,
                duration: 2000,
                ease: 'Linear',
                yoyo: false,
                repeat: 0,
                onComplete: () => {
                    this.scene.sleep(this)
                }
            })
        }, this)
    }

    onSceneWake() {
        this.bgEvents = structuredClone(this.eventQueue);
        this.addEventListeners();
        this.fadeInBackground();
    }

    quizEventHandler() {
        const quiz = this.scene.get('Quiz');
        quiz.events.on('scroll-speed-changed', (data) => {
            this.scrollSpeed = data.scrollSpeed;
        }, this)

        quiz.events.on('reset', () => {
            this.bgEvents = structuredClone(this.eventQueue);
            if(this.deerScene) {
                this.deerScene.removeDeer();
                this.deerScene.readyToCreateAnimals = true;
            }
            if(this.ducks != undefined && this.ducks.getChildren().length > 0){
                this.ducks.clear(true, true);
            }

        })
    }


    resetBackground() {
        this.bgEvents = structuredClone(this.eventQueue);
        this.addEventListeners();
        this.fadeInBackground();
    }

    fadeInBackground = () => {
        this.add.tween({
            targets: this.roadReflection,
            alpha: 0.8,
            duration: 2000,
            ease: 'Linear',
            yoyo: false,
            repeat: 0
        })

        this.add.tween({
            targets: this.bgTreesReflection,
            alpha: 0.4,
            duration: 2000,
            ease: 'Linear',
            yoyo: false,
            repeat: 0
        })

        this.add.tween({
            targets: this.skyReflection,
            alpha: 0.3,
            duration: 2000,
            ease: 'Linear',
            yoyo: false,
            repeat: 0
        })

        this.add.tween({
            targets: [this.sky, this.bgTrees, this.road, this.waterOverlay, this.ripples, this.lakeGround, this.sasquatch],
            alpha: 1,
            duration: 2000,
            ease: 'Linear',
            yoyo: false,
            repeat: 0
        })
    }
}

export default ReflectionBackground;